export const CONTRACT_TEMPLATE = {
    title: '房屋租赁合同',
    protocols: [
        {
            clauses: [
                { subtitle: '出租方：_________' },
                { subtitle: '承租方：_________' }
            ]
        },
        {
            clauses: [ 
                { intro: '根据《中华人民共和国合同法》、《中华人民共和国城市房地产管理法》及其他有关法律、法规规定，在平等、自愿、协商一致的基础上，租赁双方就出租方将房屋出租于承租方事宜达成如下协议。'}
            ]
        },
        {
            clauses: [
                {
                    subtitle: '第一条 出租房屋情况和租赁用途',
                    details: [
                        { text: '出租方将坐落在____分间部位____的居住房屋（简称“该房屋”）出租给承租方。' },
                        { text: '承租方向出租方承诺，承租该房屋仅用作居住使用。' },
                        { text: '租赁期间，承租方可使用的该房屋公用或合用部位的使用范围，现有的装修、附属设施、设备状况以及需约定的有关事项，由租赁双方在本合同补充条款中加以列明，作为出租方交付该房屋和本合同终止时承租方返还该房屋的验收依据。' }
                    ]
                },
                {
                    subtitle: '第二条 交付日期和租赁期限',
                    details: [
                        { text: '租赁双方约定，该房屋租赁期起止时间为____。' },
                        { text: '租赁双方同意，出租方于____前将该房屋交付给承租方，由承租方进行验收。逾期交付的，每逾期一日，承租方有权要求出租方向其支付日租金的____壹____倍作为违约金。' }
                    ]
                },
                {
                    subtitle: '第三条 租金及付款方式',
                    details: [
                        { text: '租赁双方约定，在上述租赁期限内，该房屋月租金为____元。在租赁期限内，未经租赁双方协商一致，出租方不得擅自调整租金标准。' },
                        { text: '租赁双方约定，租金每____个月一付。承租方应提前____日通过六六找房平台向出租方支付下一期租金，具体支付方式详见六六找房平台。逾期支付的，每逾期一日，出租方有权要求承租方向其支付日租金的____壹____倍作为违约金。' }
                    ]
                },
                {
                    subtitle: '第四条 押金和其他费用',
                    details: [
                        { text: '租赁双方约定，签订房屋租赁合同后，承租方必须通过六六找房平台向出租方支付房屋租赁押金，押金金额为____元，具体支付方式详见六六找房平台。本合同终止时，出租方收取的房屋租赁押金除用以抵充本合同约定由承租方承担但还未交纳的费用外，剩余部分无息返还承租方。' },
                        { text: '租赁期间，该房屋所发生的水费、电费、煤/燃气费、通讯费、取暖费、有线电视费等费用由承租方承担，其中上述费用应由出租方分担的，具体的费用分担比例或金额，由租赁双方在合同补充条款中约定。除上述费用外，物业管理费、服务费等其他本协议未提及费用由租赁双方协商约定具体承担方。' }
                    ]
                },
                {
                    subtitle: '第五条 出租方的权利与义务',
                    details: [
                        { text: '出租方保证有权出租该房屋，该出租行为已取得所有房屋权利人同意。' },
                        { text: '出租方应确保该房屋交付时符合规定的安全条件。租赁期间，承租方发现该房屋及本合同补充条款中列明的附属设施、设备有损坏或故障时，应及时通知出租方修复；出租方应在接到承租方通知后的____7____日内进行维修或委托承租方进行维修。出租方逾期不维修、也不委托承租方进行维修的，承租方可代为维修，费用由出租方承担。' },
                        { text: '租赁期间，出租方应定期对该房屋进行检查、养护，保证该房屋及其附属设施、设备处于正常的可使用和安全的状态。出租方应在检查养护前____7____日通知承租方。检查养护时，承租方应予以配合。出租方应减少对承租方使用该房屋的影响。' }
                    ]
                },
                {
                    subtitle: '第六条 承租方的权利与义务',
                    details: [
                        { text: '承租方保证提供的所有材料真实，保证租赁用途符合本合同约定，且承租方对该房屋的使用不得违反法律法规的规定。如承租方违反上述保证，出租方有权单方面解除本合同并收回房屋，押金不予退还，因此产生的损失由承租方负责赔偿。' },
                        { text: '承租方应按照本合同的约定，按时、足额向出租方支付租金押金等应付的款项。' },
                        { text: '在承租方的承租期内，水费、电费、煤/燃气费等生活费用由承租方自行承担，承租方应在本合同解除时结清。' },
                        { text: '承租方应对该房屋的使用安全负责。租赁期间，承租方应合理使用并爱护该房屋及其附属设施、设备，因承租方使用不当或不合理使用，致使该房屋及其附属设施、设备损坏或发生故障的，承租方应负责修复。承租方不维修的，出租方可代为维修，费用由承租方承担。' },
                        { text: '承租方需装修或者增设附属设施和设备的，应在签订本合同时，在本补充条款中约定；如在本合同补充条款中未约定的，则应事先征得出租方的同意。按规定须向有关部门报批的，则应由出租方或出租方委托承租方报请有关部门批准后，方可进行。承租方另需装修或者增设的附属设施和设备的归属、维修责任及合同终止后的处置，由租赁双方在本合同补充条款中约定。' }
                    ]
                },
                {
                    subtitle: '第七条 转租、承租权转让和交换',
                    details: [
                        { text: '租赁期间，承租方将该房屋部分或全部转租给他人，应事先征得出租方的书面同意，并符合国家和本市有关房屋租赁的规定。承租方转租该房屋的，应与次承租人订立转租合同。' },
                        { text: '租赁期间，未事先征得出租方书面同意，承租方不得将该房屋转让给他人承租或与他人承租的居住房屋进行交换。' }
                    ]
                },
                {
                    subtitle: '第八条 续租、解约和费用结算',
                    details: [
                        { text: '租赁期满，若承租方需要续租的，承租方应提前____30____日向出租方提出续租要求，双方协商一致后重新签订《房屋租赁合同》。租赁期满，若承租方不续租的，在未提前告知出租方情况下，承租方不承担法律责任。' },
                        { text: '租赁期满，租赁双方未续签租赁合同，承租方继续支付租金而出租方未表示拒绝的，按相关法律法规规定，租赁双方成立不定期租赁关系。在不定期租赁关系中，出租方有权解除租赁关系，出租方提出解除租赁关系的，应自通知承租方之日起，给予承租方____30____日的宽限期。宽限期内，承租方应按本合同的约定，向出租方支付该房屋的租金以及由承租方承担的其他费用。' },
                        { text: '租赁期满前，若出租方准备另行出租他人，需在租赁期满前____30____日告知承租方，同等条件下，承租方享有优先承租的权利。' },
                        { text: '租赁双方约定终止本合同的，租赁双方必须在六六找房平台签订解约协议，结清租赁双方各自承担的费用。出租方必须在费用结清当日向承租方退还承租方已缴纳的押金、剩余租金和预付的其他费用的剩余部分。' }
                    ]
                },
                {
                    subtitle: '第九条 房屋返还',
                    details: [
                        { text: '承租方应在本合同的租期届满后____当____日内返还该房屋，结清相应款项，保证房屋设施完好，房内清洁，承租方未经出租方同意逾期返还该房屋的，每逾期一日，承租方应向出租方支付日租金的____壹____倍作为违约金。' },
                        { text: '除本合同补充条款另有约定外，承租方返还该房屋时，该房屋及其装修、附属设施和设备应当符合正常使用后的状态，经出租方验收认可后，相互结清各自应当承担的费用。' }
                    ]
                },
                {
                    subtitle: '第十条 解除本合同的条件',
                    details: [
                        { text: '租赁双方同意在租赁期内，有下列情形之一的，本合同解除，双方互不担责：', subjects: [
                            '该房屋占用范围内的土地使用权依法提前收回的；',
                            '该房屋因公共利益需要被依法征收的；',
                            '该房屋因城市建设需要被依法列入房屋拆迁许可范围的；',
                            '该房屋因不可抗力原因毁损、灭失，致使承租方不能正常使用的；',
                            '签订本合同时，出租方已告知承租方该房屋已设定抵押，租赁期间被处分的；',
                            '租赁双方协商一致解除本合同的。'
                        ] },
                        { text: '租赁双方同意，出租方有下列违约情形之一的，承租方可通知出租方解除本合同，并有权要求出租方赔偿损失：', subjects: [
                            '出租方未按合同约定按时交付该房屋，经承租方催告后____3____日内仍未交付的；',
                            '出租方交付的该房屋不符合本合同约定或存在重大质量缺陷，致使承租方不能正常使用的。'
                        ] },
                        { text: '租赁双方同意，承租方有下列违约情形之一的，出租方可通知承租方解除本合同，并有权要求承租方赔偿损失：', subjects: [
                            '承租方擅自改变房屋居住用途的；',
                            '因承租方原因造成房屋结构损坏的；',
                            '承租方擅自转租该房屋、转让该房屋承租权或与他人交换各自承租的房屋的；',
                            '承租方利用承租的居住房屋从事违法违规活动的；',
                            '承租方逾期超过____7____日未在六六找房平台支付租金的。'
                        ] }
                    ]
                },
                {
                    subtitle: '第十一条 违约责任',
                    details: [
                        { text: '出租方的违约责任', subjects: [
                            '该房屋交付验收时，现有的装修、附属设施、设备存在缺陷，影响承租方正常使用的，出租方应自交付之日起的____14____日内进行修复。逾期不修复的，出租方同意减少该房屋的租金并变更相关条款。',
                            '出租方未在本合同中告知承租方，该房屋出租前已抵押，造成承租方损失的，出租方应负责赔偿。',
                            '租赁期间，出租方不及时履行本合同约定的维修、养护责任，致使房屋及其附属设施、设备损坏，造成承租方财产损失或人身伤害的，出租方应承担赔偿责任。',
                            '租赁期间，非本合同10-3 条款约定的情形，出租方提前解除合同的，应与承租方协商一致，并按房屋租赁押金的____壹____倍向承租方支付违约金。若违约金不足抵付承租方损失的，出租方还应负责赔偿损失与违约的差额部分。未与承租方协商一致的，出租方不得提前收回该房屋。',
                        ] },
                        { text: '承租方的违约责任', subjects: [
                            '承租方逾期支付租金的（非承租方因素除外），每逾期一日，出租方有权要求承租方向其支付日租金的____壹____倍作为违约金。逾期返还该房屋的，每逾期一日，出租方有权要求承租方向其支付日租金的____壹____倍作为违约金。',
                            '承租方未征得出租方同意或者超出出租方同意的范围擅自装修房屋或者增设附属设施的，出租方可以要求承租方恢复房屋原状。租赁期间，若因承租方原因致房屋损坏，造成出租方财产损失或人身伤害的，承租方应承担赔偿责任。',
                            '租赁期间，非本合同10.2 条款约定的情形，承租方中途擅自退租的，承租方应按房屋租赁押金的____壹____倍向出租方支付违约金。若违约金不足以抵付出租方损失的，承租方还应负责赔偿损失与违约的差额部分。'
                        ] }
                    ]
                },
                {
                    subtitle: '第十二条 解决争议的方式',
                    details: [
                        { text: '双方在履行本合同过程中若发生争议的，租赁双方可协商解决或者向人民调解委员会申请调解，协商不成的，可向房屋所在地人民法院提起诉讼。' }
                    ]
                },
                {
                    subtitle: '第十三条 其他条款',
                    details: [
                        { text: '出租方________在承租方承租期间为该房屋购买租房保险，且保证承租期间保险合同合法有效。若因出租人承诺购买上述租房保险而未购买或保险合同期满未续保的，承租人有权拒绝赔付非承租人恶意损坏的家具家电装潢等物品损失。' },
                        { text: '租赁双方约定，租赁期间，租赁任意一方可为该房屋本身及屋内财产进行保险投保，由保险公司就保险标的按照保险合同约定给予赔偿，双方必须配合完成理赔事宜。保险期限内，若因承租方使用不当或不合理使用，致使该房屋装修、家具、家电等损坏需要承租方赔偿的，出租方优先通过保险理赔，保险理赔金额不足以赔付的，由承租方补齐差额。' },
                        { text: '租赁双方应当通过六六找房平台支付收取租金押金，该条款为用户使用平台服务必备条款，双方不得通过补充条款或协议进行变更。' },
                        { text: '本合同未尽事宜，经租赁双方协商一致，可订立补充条款。本合同补充条款，为本合同不可分割的一部分。' },
                        { text: '在签订本合同前，租赁双方已线下沟通看房，充分了解并接受该租赁房屋的现有结构、附属设备及其他与房屋相关的信息。' },
                        { text: '本合同系电子文本，经租赁双方在系统点击确定签订后生效。本合同由六六找房平台留存，租赁双方可通过平台自行下载。' },
                        { text: '租赁一方存在违约或侵权行为时，相对方为此提起诉讼、或被牵连进违约方或侵权方与第三人的诉讼活动中来时，相对方因此发生的必要费用（包括但不仅限于律师代理费用），均由违约或侵权方承担。' },
                        { text: '租赁双方依双方协商的通讯地址向相对方以快递方式邮寄书面通知或其他法律文件的，投邮超过5日即视为受达。合同当事方若要变更通讯地址的，应由双方共同确认方可生效。' }
                    ]
                },
                {
                    subtitle: '第十四条 补充条款',
                    examples: [
                        { text: '补充条款内容与以上条款内容（除必备条款外）有冲突的，以补充条款为准。' },
                        { text: '___________________________', separate: true }
                    ]
                },
                {
                    examples: [
                        { text: '出租方：_________' },
                        { text: '证件类型：_________' },
                        { text: '证件号码：_________' },
                        { text: '联系方式：_________' },
                        { text: '签署时间：_________', separate: true }
                    ]
                },
                {
                    examples: [
                        { text: '承租方：_________' },
                        { text: '证件类型：_________' },
                        { text: '证件号码：_________' },
                        { text: '联系方式：_________' },
                        { text: '签署时间：_________' }
                    ]
                }
            ]
        }
    ]
}